import React, { useEffect, useState } from "react";
import { Checkbox } from "@my-scoot/component-library-legacy";
import { is_empty } from "utils/validations";
import {
  TRANSACTIONS_REFUND_OPTIONS,
  TRANS_CONSTANTS,
} from "../../transactions.constants";
import styles from "./InitiateRefund.module.css";
import { Button, Tooltip } from "@my-scoot/component-library-legacy";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { REFUND_PAGES } from "features/Crm/modules/Transactions/modules/Refund/Refund.constants";
import { InitiateRefundModalContext } from "../../AllTransaction";
import { isCustomRefundAmountType } from "../../utils/AllTransaction.util";
import { useWallets } from "features/Account/modules/Wallets/utils/useWallets";
import { useWalletStore } from "features/Account/modules/Wallets/store/WalletStore";
import { walletKeys } from "features/Account/modules/Wallets/constants/Wallets.constants";
import { getAmountWithCurrenyString } from "features/Account/modules/Wallets/utils/Wallets.utils";

const RefundModalFooter = () => {
  const {
    activeRefundPage,
    setActiveRefundPage,
    refundAmountData,
    handlePayNow,
    refundButtonDisabled,
    selectedRefundType,
  } = React.useContext(InitiateRefundModalContext);
  const isCustomRefund = isCustomRefundAmountType(
    TRANSACTIONS_REFUND_OPTIONS[selectedRefundType]
  );

  const { walletBalance, refreshWalletBalance } = useWallets({
    isFetchWalletBalanceEnabled: true,
  });
  const isPayViaWallet = useWalletStore((state) => state.isPayViaWallet);
  const setIsPayViaWallet = useWalletStore((state) => state.setIsPayViaWallet);
  const isWalletActive = useWalletStore((state) => state.isWalletActive);
  const [isCompletePaymentFromWallet, setIsCompletePaymentFromWallet] =
    useState(false);

  const {
    payable_amount: payableAmount,
    refund_amount: refundAmount,
    amount_held_with_exly,
    tax_amount,
    rihf_fees_exclusive_of_tx,
  } = refundAmountData;

  const [payableAmountInFractions, setPayableAmountInFractions] = useState(
    parseFloat(payableAmount ?? 0).toFixed(TRANS_CONSTANTS.place_after_decimal)
  );

  const refundAmountInFractions = parseFloat(refundAmount ?? 0).toFixed(
    TRANS_CONSTANTS.place_after_decimal
  );

  const [amountFromWallet, setAmountFromWallet] = useState(
    parseFloat(payableAmount ?? 0).toFixed(TRANS_CONSTANTS.place_after_decimal)
  );

  const handleWalletSelectionChange = (e) => {
    setIsPayViaWallet(e?.target.checked);
    if (e?.target?.checked) {
      if (
        parseFloat(payableAmountInFractions) <=
        parseFloat(walletBalance?.[walletKeys.walletBalance])
      ) {
        setIsCompletePaymentFromWallet(true);
        setAmountFromWallet(payableAmountInFractions);
        setPayableAmountInFractions(0);
      } else {
        setAmountFromWallet(walletBalance?.[walletKeys.walletBalance]);
        setPayableAmountInFractions(
          (
            parseFloat(payableAmountInFractions) -
            parseFloat(walletBalance?.[walletKeys.walletBalance])
          ).toFixed(TRANS_CONSTANTS.place_after_decimal)
        );
      }
    } else {
      setPayableAmountInFractions(
        parseFloat(payableAmount ?? 0).toFixed(
          TRANS_CONSTANTS.place_after_decimal
        )
      );
    }
  };

  useEffect(() => {
    setPayableAmountInFractions(
      parseFloat(payableAmount ?? 0).toFixed(
        TRANS_CONSTANTS.place_after_decimal
      )
    );
  }, [payableAmount]);

  useEffect(() => {
    refreshWalletBalance();
  }, []);

  // TODO: separate module in features/refund
  const tooltip = (
    <div>
      <table>
        <tbody>
          <tr>
            <td>Amount to be refunded:</td> &nbsp;
            <td>₹ {refundAmountInFractions}</td>
          </tr>
          <tr>
            <td>Amount held with Exly:</td> &nbsp;
            <td>
              ₹{" "}
              {parseFloat(amount_held_with_exly)?.toFixed(
                TRANS_CONSTANTS.place_after_decimal
              )}
            </td>
          </tr>
          <tr>
            <td>Refund handling fees:</td> &nbsp;
            <td>
              ₹{" "}
              {parseFloat(rihf_fees_exclusive_of_tx)?.toFixed(
                TRANS_CONSTANTS.place_after_decimal
              )}
            </td>
          </tr>
          <tr>
            <td>GST:</td> &nbsp;
            <td>
              ₹{" "}
              {parseFloat(tax_amount)?.toFixed(
                TRANS_CONSTANTS.place_after_decimal
              )}
            </td>
          </tr>
          {/* this is to show the user what amount is being used fom the wallet */}
          {isPayViaWallet && (
            <tr>
              <td>Amount used from wallet:</td> &nbsp;
              <td>₹ {amountFromWallet}</td>
            </tr>
          )}

          <tr>
            <td>Amount to initiate refund:</td> &nbsp;
            <td>₹ {payableAmountInFractions}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );

  const footer = () => {
    if (activeRefundPage === REFUND_PAGES.reviewSelection) {
      return (
        <div
          className={`${styles.footer} d-flex justify-content-center align-items-center`}
        >
          <Button
            onClick={() => setActiveRefundPage(REFUND_PAGES.initiateRefund)}
            color="primary"
            disabled={refundButtonDisabled}
          >
            Confirm & Proceed
          </Button>
        </div>
      );
    }

    const hasRefundAmountData = !is_empty(refundAmountData);

    if (!selectedRefundType) return <div className={styles.footer} />;

    // show refund breakdown only
    // if: hasRefundAmountData exists
    //     AND
    //     refund amount > 0
    // NOTE: hasRefundAmountData is response from TRANSACTION_APIS.validate_refunds(payments/validate/refunds) api
    const showTooltip = hasRefundAmountData && refundAmountInFractions > 0;

    return (
      <>
        {isWalletActive && (
          <>
            <div className="tw-flex tw-items-center tw-justify-between tw-bg-[#F2F0FF] tw-leading-[14.32px] tw-p-[10px] tw-text-black tw-w-full tw-mt-[20px]">
              <span className="tw-text-[14px] tw-ml-[24px] tw-flex tw-items-center tw-gap-[10px]">
                <Checkbox
                  size="large"
                  wrapperClassName="!tw-border-[1.5px] !tw-border-solid !tw-border-[#493AB1]"
                  disabled={
                    walletBalance?.[walletKeys.walletBalance] ? false : true
                  }
                  checked={isPayViaWallet}
                  onChange={handleWalletSelectionChange}
                />
                <span className="tw-font-medium">
                  Use Exly Wallet balance
                  {"  "}
                  <span className="!tw-font-normal tw-text-[#27252299]">
                    (Current balance:{" "}
                    {getAmountWithCurrenyString(
                      walletBalance?.[walletKeys.walletBalance]
                    )}
                    )
                  </span>
                </span>
              </span>
              {/* uncomment when top up will be enabled */}
              {/* {payableAmountInFractions >
              walletBalance?.[walletKeys.walletBalance] ? (
                <Button
                  color="link"
                  size="small"
                  className="!tw-bg-transparent !tw-h-[14px] !tw-underline"
                  onClick={handleTopUpWalletClick}
                >
                  <span className="!tw-text-[14px] tw-text-[#493AB1]">
                    Top-up wallet
                  </span>
                </Button>
              ) : null} */}
            </div>
          </>
        )}
        <div className={styles.footer}>
          <div>
            <span>Amount to initiate refund:</span>
            &nbsp;
            <strong>₹ {payableAmountInFractions}</strong>
            &nbsp;
            {showTooltip ? (
              <Tooltip title={tooltip} color="primary" arrow>
                <InfoOutlinedIcon className={styles.tooltip} />
              </Tooltip>
            ) : null}
          </div>
          <Button
            onClick={handlePayNow}
            color="primary"
            disabled={refundButtonDisabled}
            loading={refundButtonDisabled}
          >
            {is_empty(parseInt(payableAmountInFractions)) &&
            !isCustomRefund &&
            isCompletePaymentFromWallet
              ? `Confirm Wallet Debit of ${getAmountWithCurrenyString(
                  amountFromWallet
                )}`
              : isPayViaWallet &&
                !isCompletePaymentFromWallet &&
                !isCustomRefund
              ? "Refund Now"
              : "Pay now"}
          </Button>
        </div>
      </>
    );
  };

  return footer();
};

export default RefundModalFooter;
